// extracted by mini-css-extract-plugin
export default {"content":"CheckoutLoadingModal_content__6C5fM","text":"CheckoutLoadingModal_text__pc61t"};